import React from 'react';
import {
  CheckoutProduct,
  GetCheckoutProductsResponse,
  Partner,
} from '../../../PulsoidClient';

import css from './PartnerVideoSection.module.css';
import {Action} from '../../../system/buttons';
import {PartnerPricingBlock} from './PartnerPricingBlock/PartnerPricingBlock';
import {TwitchPlayer} from 'react-twitch-embed';
import YouTubePlayer from 'react-player/youtube';
import {getPricingBlockLabel} from '../partnerPageHelpers';

type PartnerVideoSectionProps = {
  partner?: Partner;
  isTwitchOnline?: boolean;
  isUserLoggedIn?: boolean;
  isUserSubscribed?: boolean;

  checkoutInfo?: GetCheckoutProductsResponse;
  onCheckoutStart: (productId: CheckoutProduct) => void;
  onGetStarted: () => void;
};

export const PartnerVideoSection = ({
  partner,
  isTwitchOnline,
  isUserLoggedIn,
  isUserSubscribed,
  checkoutInfo,
  onCheckoutStart,
  onGetStarted,
}: PartnerVideoSectionProps) => {
  return (
    <div
      className={css.wrapper}
      style={{backgroundImage: `url(${partner?.bannerUrl})`}}
    >
      <div className={css.root}>
        <div className={css.main}>
          <div className={css.videoContainer}>
            <div className={css.video}>
              {isTwitchOnline ? (
                <TwitchPlayer
                  channel={partner?.social?.twitchUrl?.split('/').pop() || ''}
                  autoplay={true}
                  muted={false}
                  width="100%"
                  height="100%"
                />
              ) : (
                <YouTubePlayer
                  url={partner?.videoUrl}
                  width="100%"
                  height="100%"
                />
              )}
            </div>
            {!isUserLoggedIn ? (
              <Action className={css.cta} square onClick={onGetStarted}>
                get started
              </Action>
            ) : null}
          </div>

          <div className={css.checkoutContainer}>
            <h3 className={css.checkoutTitle}>my exclusive deal</h3>

            {checkoutInfo?.products.map((product) => (
              <PartnerPricingBlock
                key={product.id}
                title={product.title}
                price={product.price}
                discount={product.discount}
                buttonLabel={getPricingBlockLabel({
                  isUserLoggedIn,
                  isUserSubscribed,
                })}
                onBuyClick={() => onCheckoutStart(product)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
